// Mock data for TMD Physio website

export const heroData = {
  title: "Krina Panchal",
  subtitle: "Specialist TMD Physiotherapist",
  description: "Expert treatment for TMD, Headaches, Migraines & Tinnitus",
  ctaText: "Book Your Consultation",
  ctaSecondary: "WhatsApp Us",
  whatsappNumber: "447899121612",
  stats: [
    { value: "4.9★", label: "Google Rating", liveGoogle: true },
    { value: "15", label: "Years Experience" },
    { value: "4", label: "Days a Week Open", sublabel: "Tue – Fri", scrollTo: "#location", liveHours: true }
  ]
};

export const aboutData = {
  name: "Krina Panchal",
  title: "Specialist TMD Physiotherapist",
  image: "/images/krina-portrait.webp",
  bio: "Krina is a specialist physiotherapist with dual BSc (Hons) degrees from Manchester Metropolitan University — in Biomedical Science and in Physiotherapy — a Masters Module from the University of Liverpool in Assessment and Management of TMD, and 15+ years of clinical experience focused on temporomandibular disorders (TMD), chronic headaches, migraines, and somatic tinnitus. Her postgraduate training spans the Institute of Functional Medicine (AFMCP, Washington DC), the Watson Headache® approach, CRAFTA® craniofacial therapy, Instituto Rocabado's BOSCO TMD course, an Orofacial Pain Clinic placement at Columbia University, the Steve Kraus Physical Therapy TMD course in Atlanta, the TreatingTMJ Course by Michael Karegeannes (2025), and the Cervico-Cranio-Mandibular Academy advanced TMD courses (2025). She has been invited to lecture on University College London's MSc Audiology programme. Krina is a past Committee Member of the Association of Chartered Physiotherapists treating Temporomandibular Disorders (ACPTMD, 2017–2019), and currently sits on the CSP and HCPC registers.",
  // Grouped credentials for the visible About section. Flat `credentials`
  // below is kept for downstream consumers that expect the legacy array.
  credentialGroups: [
    {
      title: "Degrees",
      items: [
        "BSc (Hons) Biomedical Science — Manchester Metropolitan University",
        "BSc (Hons) Physiotherapy — Manchester Metropolitan University",
        "Masters Module in Assessment & Management of TMD — University of Liverpool",
      ],
    },
    {
      title: "Postgraduate Training",
      items: [
        "Steve Kraus Physical Therapy & TMD Course — Atlanta, USA (2014)",
        "Columbia University — Shadowing the Orofacial Pain Clinic (2014)",
        "CRAFTA® Foundation Course, Parts 1 & 2 — Italy (2016)",
        "Watson Headache® Course, Foundation — London (2017)",
        "Instituto Rocabado — BOSCO TMD Course (2017)",
        "Institute of Functional Medicine — AFMCP Foundation Course (Cohort 108), Washington DC, USA",
        "Nutritional Therapy Diploma — London",
        "Dry Needling, Levels 1 & 2 — London",
        "Myofascial Taping Foundation — London",
        "Pilates — London",
        "Diploma in Massage — London",
      ],
    },
    {
      title: "Teaching & Memberships",
      items: [
        "Invited Lecturer — UCL MSc Audiology (2025)",
        "Chartered Society of Physiotherapy (CSP)",
        "Health and Care Professions Council (HCPC) registered",
        "Past Committee Member, Association of Chartered Physiotherapists treating TMD (ACPTMD) — 2017–2019",
      ],
    },
  ],
  credentials: [
    "BSc (Hons) Biomedical Science — Manchester Metropolitan University",
    "BSc (Hons) Physiotherapy — Manchester Metropolitan University",
    "Masters Module in Assessment & Management of TMD — University of Liverpool",
    "Steve Kraus Physical Therapy & TMD Course — Atlanta, USA (2014)",
    "Columbia University — Shadowing the Orofacial Pain Clinic (2014)",
    "CRAFTA® Foundation Course, Parts 1 & 2 — Italy (2016)",
    "Watson Headache® Course, Foundation — London (2017)",
    "Instituto Rocabado — BOSCO TMD Course (2017)",
    "Institute of Functional Medicine — AFMCP Foundation Course (Cohort 108)",
    "TreatingTMJ Course by Michael Karegeannes — Freedom Physical Therapy Services, USA (2025)",
    "Cervico-Cranio-Mandibular Academy (CCMA) — Advanced TMD Courses (2025)",
    "Nutritional Therapy Diploma — London",
    "Dry Needling, Levels 1 & 2 — London",
    "Myofascial Taping Foundation — London",
    "Pilates — London",
    "Diploma in Massage — London",
    "Invited Lecturer — UCL MSc Audiology (2025)",
    "Member of the Chartered Society of Physiotherapy (CSP)",
    "Health and Care Professions Council (HCPC) registered",
    "Past Committee Member, Association of Chartered Physiotherapists treating Temporomandibular Disorders (ACPTMD) — 2017–2019",
  ]
};

/* ============================================================
   TEAM
   To replace the initial-avatar placeholders with real photos,
   simply set `image: "https://…"` on each member. Edit the
   `bio` text below too — these are tasteful placeholders.
   ============================================================ */
export const teamData = [
  {
    id: "krina",
    name: "Krina Panchal",
    role: "Lead Physiotherapist",
    initials: "KP",
    image: "/images/krina-portrait.webp",
    bio: "Specialist physiotherapist with dual BSc (Hons) degrees from Manchester Metropolitan University (Biomedical Science + Physiotherapy), a Masters Module from the University of Liverpool in Assessment & Management of TMD, and 15+ years of clinical experience focused on temporomandibular disorders, headaches, migraines and tinnitus. Postgraduate training spans the Steve Kraus TMD course (Atlanta), Columbia University's Orofacial Pain Clinic, CRAFTA® (Parts 1 & 2), Watson Headache®, Instituto Rocabado's BOSCO course, IFM's AFMCP Foundation Course 108, the TreatingTMJ Course by Michael Karegeannes (2025), the Cervico-Cranio-Mandibular Academy advanced TMD courses (2025), dry needling and nutritional therapy. Invited lecturer at UCL MSc Audiology (2025). Past Committee Member of the ACPTMD (2017–2019).",
    credentials: [
      "BSc (Hons) Biomedical Science — Manchester Metropolitan University",
      "BSc (Hons) Physiotherapy — Manchester Metropolitan University",
      "Masters Module — University of Liverpool",
      "Watson Headache® Foundation (2017)",
      "CRAFTA® Foundation Pts 1 & 2 (2016)",
      "TreatingTMJ Course by Michael Karegeannes (2025)",
      "Cervico-Cranio-Mandibular Academy — Advanced TMD (2025)",
      "Invited Lecturer — UCL MSc Audiology (2025)",
      "Past Committee Member, ACPTMD (2017–2019)",
    ],
    instagram: "https://www.instagram.com/krinapanchal/",
    instagramHandle: "@krinapanchal"
  },
  {
    id: "mercy",
    name: "Mercy Phillips",
    role: "Physio Assistant & Massage Therapist",
    initials: "MP",
    image: "/images/team-mercy.webp",
    imageObjectPosition: "center 18%",
    bio: "Mercy is a VTCT & ITEC-Accredited Advanced Skin and Massage Specialist. She holds a PG Cert in Psychotherapy and Counselling and is currently completing a MSc in Psychology, informing a calm, patient-centred approach to care. She specialises in TMJ therapy, musculoskeletal support, sports recovery, prenatal and full-body massage, and is currently training in advanced modalities including TMJ Velvet, Low Level Laser Therapy, and NESA. With a background as an NHS Speech and Language Therapy Assistant Practitioner, she brings a highly attentive, communicative, trauma-informed approach to care.",
    credentials: [
      "VTCT & ITEC-Accredited Advanced Skin and Massage Specialist",
      "PG Cert Psychotherapy & Counselling",
      "MSc Psychology (in progress)",
    ]
  },
  {
    id: "sushma",
    name: "Sushma Gurung",
    role: "Secretary & Patient Liaison",
    initials: "SG",
    image: "/images/team-sushma.webp",
    imageObjectPosition: "center 25%",
    bio: "Sushma is the friendly first point of contact for every patient and referrer. She handles booking, insurance coordination, and gentle reminders so your appointment experience runs smoothly from enquiry to discharge.",
    credentials: ["Patient Liaison", "Insurance Coordination"]
  }
];

export const interconnectedStory = {
  headline: "When Your Jaw, Your Headaches, and Your Ears Speak the Same Language",
  storyParagraphs: [
    "Most patients arrive at our clinic exhausted. They’ve been treated as if they are a collection of separate parts: a mouth to be splinted, a head to be medicated, or an ear to be checked.",
    "But your body doesn't live in silos.",
    "If you are dealing with a tight jaw, chronic headaches, and a persistent buzz or ring in your ears, you don’t have three separate diseases. You have one deeply interconnected system that is overwhelmed."
  ],
  diagramImage: "/images/diagram-trigeminal.webp",
  diagramAlt: "Trigeminal nerve anatomy diagram showing the ophthalmic (V1), maxillary (V2) and mandibular (V3) nerve branches",
  connectingTitle: "Connecting the Dots",
  connectingParagraphs: [
    "As you can see in the anatomy diagram above, the neural pathways governing your jaw, your face, and your head are intimately linked through the trigeminal nerve. Furthermore, the muscles controlling your jaw sit just millimeters away from the delicate structures of your inner ear.",
    "When your jaw joint (TMJ) becomes misaligned or inflamed, it acts like a loud, disruptive neighbor. The distress signals overflow into neighboring pathways, triggering tension headaches and phantom sounds like tinnitus.",
    "Because these symptoms constantly influence and feed into one another, a rigid, cookie-cutter treatment plan will always fall short. You can't fix a dynamic problem with a static protocol."
  ]
};

// Shared Treatment Approach for all conditions (TMD, Headache, Tinnitus, Facial Pain)
// Massage uses its own specialised approach.
const sharedTreatmentApproach = {
  introduction: "We refuse to force your unique body into a pre-packaged, rigid treatment track. Instead, during every single clinic visit, we use advanced clinical judgment to evaluate exactly which structural and neurological factors are driving your discomfort on that specific day.",
  modalities: [
    {
      name: "Specialist Jaw Care",
      description: "We integrate specialized intra-oral protocols like TMJ Velvet to directly decompress the jaw joint capsule and relieve stubborn muscular bracing.",
      target: "Intra-oral jaw decompression, muscular bracing patterns",
      benefit: "Directly unloads structural mechanical strain on the jaw joint, lowering lateral pressure on the tympanic structures."
    },
    {
      name: "Targeted Manual Therapy",
      description: "We systematically address structural triggers using precise dry needling, targeted myofascial massage, and joint mobilisations.",
      target: "Myofascial trigger points (Masseter, Temporalis, Lateral Pterygoid)",
      benefit: "Deactivates persistent muscular trigger points that cause localized jaw pain and radiate tension across the cranium."
    },
    {
      name: "Neuromodulation & Restorative Technology",
      description: "We utilize advanced NESA neuromodulation to quiet an overstimulated autonomic nervous system.",
      target: "Central and autonomic nervous system regulation",
      benefit: "Quiets central sensitization and reduces your fight or flight response."
    },
    {
      name: "Sustainable Daily Strategy",
      description: "We seamlessly pair hands-on clinical care with tailored rehabilitative exercises and practical lifestyle advice.",
      target: "Patient self-efficacy, postural habits, ergonomics",
      benefit: "Empowers you to proactively manage neural load and daily stressors, breaking the chronic pain cycle permanently."
    },
    {
      name: "Low-Level Laser Therapy",
      target: "Cellular ATP production, local joint inflammation",
      benefit: "Reduces deep inflammatory markers within the TMJ capsule that trigger referred ear discomfort and temporal head pain."
    },
    {
      name: "Dean Watson Technique",
      target: "Upper cervical spine (C1-C3) mobility and alignment",
      benefit: "Desensitizes the trigemino-cervical nucleus to directly clear cervicogenic headaches and referred craniomandibular tension."
    },
    {
      name: "TMJ Velvet",
      target: "Intra-oral jaw decompression, muscular bracing patterns",
      benefit: "Directly unloads structural mechanical strain on the jaw joint, lowering lateral pressure on the tympanic structures."
    },
    {
      name: "Dry Needling & Massage",
      target: "Myofascial trigger points (Masseter, Temporalis, Lateral Pterygoid)",
      benefit: "Deactivates persistent muscular trigger points that cause localized jaw pain and radiate tension across the cranium."
    },
    {
      name: "Joint Mobilisations",
      target: "Articular restrictions within the TMJ and cervical spine",
      benefit: "Restores normal physiological arthrokinematics to eliminate compensatory muscular guarding in the facial region."
    },
    {
      name: "Exercises & Lifestyle Advice",
      target: "Patient self-efficacy, postural habits, ergonomics",
      benefit: "Empowers the patient to proactively manage neural load and daily stressors, breaking the chronic pain cycle permanently."
    }
  ]
};

export const servicesData = [
  {
    id: 1,
    slug: 'tmd-treatment',
    title: "TMD Treatment",
    showInterconnectedStory: true,
    description: "Comprehensive assessment and treatment for temporomandibular joint disorders, including jaw pain, clicking, locking, and restricted movement.",
    icon: "Activity",
    image: "https://images.unsplash.com/photo-1757066033606-b9552acb2dd0?auto=format&fit=crop&w=1200&q=72",
    imagePosition: "50% 38%",
    benefits: [
      "Reduce jaw pain and tension",
      "Improve jaw mobility",
      "Eliminate clicking and locking",
      "Long-term relief strategies"
    ],
    treatmentApproach: sharedTreatmentApproach
  },
  {
    id: 2,
    slug: 'headache-migraine-relief',
    title: "Headache & Migraine Relief",
    showInterconnectedStory: true,
    description: "Specialized treatment for tension headaches, migraines, and cervicogenic headaches using manual therapy and targeted exercises.",
    icon: "Brain",
    image: "https://images.unsplash.com/photo-1757066033647-366cc10e0de2?w=1200&q=75&fm=jpg",
    imagePosition: "50% 72%",
    benefits: [
      "Reduce frequency and intensity",
      "Address underlying causes",
      "Drug-free pain management",
      "Prevent future episodes"
    ],
    treatmentApproach: sharedTreatmentApproach
  },
  {
    id: 3,
    slug: 'tinnitus-management',
    title: "Tinnitus Management",
    showInterconnectedStory: true,
    description: "Evidence-based physiotherapy approach to managing tinnitus through jaw and neck treatment, helping reduce symptoms and improve quality of life.",
    icon: "Ear",
    image: "https://images.unsplash.com/photo-1757041036433-e26807bda7be?w=1200&q=75&fm=jpg",
    imagePosition: "45% 32%",
    benefits: [
      "Reduce tinnitus intensity",
      "Improve sleep quality",
      "Manage associated symptoms",
      "Personalized coping strategies"
    ],
    treatmentApproach: sharedTreatmentApproach
  },
  {
    id: 4,
    slug: 'facial-pain-treatment',
    title: "Facial Pain Treatment",
    description: "Comprehensive treatment for facial pain, including trigeminal neuralgia, facial tension, and referred pain from the jaw and neck.",
    icon: "Smile",
    image: "https://images.unsplash.com/photo-1542848285-4777eb2a621e?auto=format&fit=crop&w=1200&q=72",
    imagePosition: "50% 22%",
    benefits: [
      "Relieve facial tension",
      "Reduce nerve pain",
      "Improve facial function",
      "Holistic pain management"
    ],
    treatmentApproach: sharedTreatmentApproach
  },
  {
    id: 5,
    slug: 'massage',
    title: "Massage",
    description: "Therapeutic massage techniques targeting muscles of the jaw, face, neck, and shoulders to relieve tension and promote healing.",
    icon: "Activity",
    image: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&w=1200&q=72",
    benefits: [
      "Release muscle tension",
      "Improve circulation",
      "Reduce stress and anxiety",
      "Complement other treatments"
    ],
    treatmentApproach: {
      introduction: "Therapeutic massage is a key component of our comprehensive treatment approach, targeting the interconnected muscles that contribute to jaw, head, and neck pain.",
      modalities: [
        {
          name: "Myofascial Massage",
          description: "Targeted myofascial massage addressing trigger points in the jaw, face, neck, and shoulders.",
          target: "Myofascial trigger points (Masseter, Temporalis, Lateral Pterygoid)",
          benefit: "Deactivates persistent muscular trigger points that cause localized jaw pain and radiate tension across the cranium."
        },
        {
          name: "Intra-oral Techniques",
          description: "Specialized intra-oral massage protocols to access deep jaw muscles.",
          target: "Intra-oral jaw muscles, muscular bracing patterns",
          benefit: "Directly releases internal jaw muscle tension that cannot be accessed through external massage alone."
        },
        {
          name: "Full Body Integration",
          description: "Comprehensive therapeutic massage addressing tension throughout the body that contributes to jaw and head pain.",
          target: "Whole-body muscular tension, postural compensation",
          benefit: "Releases systemic tension patterns and improves circulation to support healing and reduce stress."
        }
      ]
    },
    massageTypes: [
      {
        name: "Jaw Massage",
        description: "Specialized intraoral and external massage targeting the muscles of mastication, helping to relieve jaw tension, TMD symptoms, and facial pain.",
        benefits: [
          "Relieves jaw pain and tension",
          "Reduces clicking and popping",
          "Improves jaw mobility",
          "Addresses TMD symptoms"
        ]
      },
      {
        name: "Full Body Massage",
        description: "Comprehensive therapeutic massage addressing tension throughout the body, with emphasis on areas that contribute to jaw, neck, and head pain.",
        benefits: [
          "Whole-body relaxation",
          "Releases muscular tension",
          "Improves circulation",
          "Reduces stress and anxiety"
        ]
      },
      {
        name: "Pregnancy Massage",
        description: "Gentle, safe massage techniques specifically designed for expectant mothers, helping to alleviate pregnancy-related discomfort and tension.",
        benefits: [
          "Safe for all trimesters",
          "Reduces pregnancy discomfort",
          "Improves sleep quality",
          "Addresses postural changes"
        ]
      }
    ]
  }
];

export const processData = [
  {
    step: 1,
    title: "Initial Consultation",
    description: "We start with a thorough assessment of your symptoms, medical history, and lifestyle. This isn't a rushed appointment – we take time to understand your unique situation and goals."
  },
  {
    step: 2,
    title: "Comprehensive Assessment",
    description: "Detailed examination of your jaw, neck, and facial structures. We assess movement patterns, muscle tension, and identify the root cause of your pain."
  },
  {
    step: 3,
    title: "Personalized Treatment Plan",
    description: "Based on our findings, we create a tailored treatment plan with clear goals and timelines. You'll receive a detailed proposal explaining your condition and our recommended approach."
  },
  {
    step: 4,
    title: "Hands-On Treatment",
    description: "Evidence-based manual therapy techniques, therapeutic exercises, and self-management strategies. Each session builds on the last to achieve lasting results."
  },
  {
    step: 5,
    title: "Ongoing Support",
    description: "Once you're our patient, you have direct access for questions and concerns. We're committed to your long-term wellness, not just temporary relief."
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Diana Clutterbuck",
    condition: "TMJD",
    rating: 5,
    text: "Krina is an amazing physiotherapist, she explains everything so clearly and goes above and beyond to help, she referred me to a number of other specialists who ended up diagnosing me with other conditions seemingly unrelated to TMJD which has drastically improved my life - and all because Krina views the whole picture when treating a patient rather than focussing on her specialty which a lot of medical professionals do. I can't thank her enough for her help.",
    date: "Recent"
  },
  {
    id: 2,
    name: "Gabriel Speechly",
    condition: "TMJ Disorder",
    rating: 5,
    text: "Krina was invaluable in helping me manage my TMJ disorder, through treating me with her advanced equipment, and giving me the techniques to avoid flare-ups in the future. Can't recommend enough.",
    date: "Recent"
  },
  {
    id: 3,
    name: "Katie Taylor",
    condition: "Hip/Groin Pain",
    rating: 5,
    text: "I started with pain deep within my hip/groin area and even though I had a competent personal trainer he recommended me to Krina. I had instant pain relief after the first treatment. She would explain all home exercises very clearly which increased my compliance. I would strongly recommend her to all my family and friends as I have fully recovered from all pain.",
    date: "Recent"
  },
  {
    id: 4,
    name: "Carl Benton",
    condition: "Knee Injury",
    rating: 5,
    text: "I have had issues with my knees for a while and injured one of them at the gym. Krina's in-depth knowledge of biomechanics gave me the confidence to trust her in aiding my recovery. She supplied me with some structured stretching and strengthening exercises. I was once very wary of running with the pain it caused, however now I'm running 10k a couple of times a week.",
    date: "Recent"
  },
  {
    id: 5,
    name: "Simon Negretti",
    condition: "Multiple Injuries",
    rating: 5,
    text: "Krina has been treating me for the last 2 years. She is excellent at her job solving all my many injuries. She is always on time, extremely polite and is very popular with all her clients. I couldn't recommend her more highly.",
    date: "2 years"
  },
  {
    id: 6,
    name: "Pallavi Sharma",
    condition: "Sports Injuries",
    rating: 5,
    text: "I have visited many physios and sports therapists over the years. Krina, out of all those I have seen, has shared and demonstrated a knowledge of her field which has resulted in a much speedier recovery, aided by exercises to be done at home that were easy to grasp, manageable to do and effective.",
    date: "Recent"
  }
];

export const faqData = [
  {
    // AI/GEO answer-block phrasing — matches verbatim queries hitting
    // Perplexity / ChatGPT Search / Google AI Overviews.
    question: "Can physiotherapy cure tinnitus?",
    answer: "Physiotherapy can significantly reduce or eliminate somatosensory tinnitus — the subtype driven by dysfunction in the temporomandibular joint (TMJ) and upper cervical spine, estimated to account for 25–30% of all tinnitus cases. By treating the somatic input converging on the dorsal cochlear nucleus (via jaw mobilisation, intra-oral myofascial release, and cervical manual therapy), patients frequently experience reduced loudness, intrusiveness or full resolution of ringing. Purely inner-ear (sensorineural) tinnitus is harder to treat, but even here, addressing musculoskeletal contributors often makes symptoms less bothersome."
  },
  {
    question: "What happens during a TMJ physiotherapy assessment?",
    answer: "A first-visit TMJ physiotherapy assessment with Krina Panchal lasts 60 minutes and includes: (1) a detailed clinical history covering jaw, headache, tinnitus and dental history, (2) measurement of mandibular range of motion, deviation and joint sounds, (3) palpation of the temporomandibular joint, masseter, temporalis and lateral/medial pterygoid muscles, (4) assessment of the upper cervical spine (C1–C3) using Watson Headache® provocation tests, (5) postural, cranial nerve and neurological screening, and (6) a personalised treatment plan with a clear estimate of how many sessions you will need. Most patients receive their first hands-on treatment in the same session."
  },
  {
    question: "Does health insurance cover TMJ physiotherapy?",
    answer: "Yes — The TMD Physio is an approved provider for Cigna, WPA, Bupa Global and Healix Health, all of whom typically cover TMJ physiotherapy with a valid policy code. We do NOT currently accept Bupa (UK), AXA PPP, Aviva or Vitality — but we can still provide detailed self-pay invoices for these insurers and many patients successfully reclaim via out-of-network routes. Self-pay is available with flexible payment options and block packages."
  },
  {
    question: "Do you accept insurance?",
    answer: "We accept Cigna, WPA, Bupa Global and Healix Health. We do NOT accept Bupa (UK), AXA PPP, Aviva or Vitality — we can still provide detailed self-pay invoices for these providers, and many patients reclaim through their plan's out-of-network route. For self-pay, we offer flexible payment options and block packages."
  },
  {
    question: "What should I bring to my first appointment?",
    answer: "Please bring any relevant medical reports, imaging results (X-rays, MRI scans), a list of current medications, and your insurance details if applicable. Wear comfortable clothing that allows access to your neck and jaw area."
  },
  {
    question: "How is TMD physiotherapy different from regular physiotherapy?",
    answer: "TMD physiotherapy requires specialized training in jaw anatomy, biomechanics, and the complex relationship between the jaw, neck, and head. Krina has undertaken extensive postgraduate training specifically in TMD and cranial therapy, which isn't covered in standard physiotherapy training."
  },
  {
    question: "Do you offer emergency appointments?",
    answer: "We understand that jaw pain and severe headaches can be debilitating. While we don't typically offer same-day emergency appointments, we prioritize urgent cases and will do our best to see you as quickly as possible. Contact us via WhatsApp or phone to discuss your needs."
  },
  {
    question: "What is TMD and what are the most common symptoms?",
    answer: "Temporomandibular Joint Disorder (TMD) refers to issues affecting the jaw joint and surrounding muscles. Common symptoms include localized jaw pain, clicking or popping sounds when chewing, limited jaw movement, locked jaw, facial tension, headaches, and jaw-related tinnitus."
  },
  {
    question: "Can a specialized physiotherapist really fix jaw clicking and popping?",
    answer: "Yes, absolutely. Jaw clicking is frequently caused by a displaced joint disc or muscle imbalances. Focused TMD physiotherapy uses targeted joint mobilization, trigger point therapy, and neuromuscular retraining to safely restore proper alignment and eliminate clicking."
  },
  {
    question: "What should I expect during my initial TMD consultation at your London clinic?",
    answer: "Your initial visit involves a comprehensive assessment of your jaw range of motion, joint tracking, cervical spine posture, and masticatory muscle palpation. We isolate the root neuromuscular cause of your symptoms to construct a custom treatment pathway."
  },
  {
    question: "Can jaw joint issues cause tinnitus, ear pain, or dizziness?",
    answer: "Yes, there is a profound structural and neurological connection between the jaw and the ears. TMD can cause somatic tinnitus (ringing in ears without hearing loss), a feeling of ear fullness, and vertigo due to proximity and shared nerve pathways."
  },
  {
    question: "How many physiotherapy sessions will I need to resolve my jaw pain?",
    answer: "While every case varies, many patients experience noticeable symptomatic relief within 3 to 6 targeted treatment sessions. Chronic, complex, or multi-year cases may require an extended structural rehabilitation protocol combined with dental splint therapies."
  },
  {
    question: "Is a referral from a dentist or GP required to book an appointment?",
    answer: "No medical or dental referral is required to book a private assessment at our Waterloo clinic. You can book directly with our clinical team, though we regularly collaborate with dental specialists for integrated care."
  },
  {
    question: "Do you offer specialized treatment for chronic migraines and headaches?",
    answer: "Yes. Chronic tension headaches and persistent migraines are frequently referred pain patterns radiating from hyperactive jaw muscles and upper cervical spinal dysfunctions. TMD physiotherapy addresses these root triggers directly."
  },
  {
    question: "How does your practice coordinate care with dental specialists?",
    answer: "We run an integrated clinical cross-referral pathway. If your TMD is caused or aggravated by structural bite issues, we partner with specialized dentists to coordinate custom stabilizing splint therapy alongside physical rehabilitation."
  },
  {
    question: "Are jaw exercises safe to perform at home without supervision?",
    answer: "Home exercises are an essential part of your recovery, but they must be precisely calibrated to your specific joint tracking. Performing generic exercises found online can worsen disc displacements, so we provide an individualized prescription."
  },
  {
    question: "Where is your Central London clinic located, and do you offer evening appointments?",
    answer: "The clinic is in Waterloo at 121 Westminster Bridge Road, London SE1 7HR, a minute from Lambeth North. Appointments run Tuesday 10:15am–1:30pm, Wednesday and Friday 8am–7pm, and Thursday 10am–8pm, so Thursday evenings until 8pm and Wednesday or Friday from 8am suit most working days."
  }
];

// Doctify profile — static score (Doctify has no public API; update as reviews grow)
export const doctifyData = {
  rating: 4.9,
  count: 10,
  url: "https://www.doctify.com/uk/specialist/ms-krina-panchal-7/reviews/page-1",
};

export const insuranceData = [
  // ACCEPTED — colour logos rendered on the site.
  {
    name: "Cigna",
    accepted: true,
    logo: "/logos/insurers/cigna.svg",
    domain: "cigna.com",
  },
  {
    name: "WPA",
    accepted: true,
    logo: "/logos/insurers/wpa.png",
    domain: "wpa.org.uk",
  },
  {
    name: "Bupa Global",
    accepted: true,
    logo: "/logos/insurers/bupa-global.png",
    domain: "bupaglobal.com",
  },
  {
    name: "Healix Health",
    accepted: true,
    logo: "/logos/insurers/healix.png",
    domain: "healix.com",
  },
  // NOT ACCEPTED — same logo URLs rendered with CSS `filter: grayscale(1)`
  // so we don't ship a second set of assets.
  {
    name: "Bupa",
    accepted: false,
    logo: "/logos/insurers/bupa-uk.png",
    domain: "bupa.co.uk",
  },
  {
    name: "AXA PPP Healthcare",
    accepted: false,
    logo: "/logos/insurers/axa.png",
    domain: "axahealth.co.uk",
  },
  {
    name: "Aviva",
    accepted: false,
    logo: "/logos/insurers/aviva.png",
    domain: "aviva.co.uk",
  },
  {
    name: "Vitality Health",
    accepted: false,
    logo: "/logos/insurers/vitality.png",
    domain: "vitality.co.uk",
  },
];

// Referral form dropdown options
export const referralFormOptions = {
  primaryConditions: [
    "TMD / Jaw Pain",
    "Headache & Migraine",
    "Tinnitus",
    "Facial Pain",
    "Massage / Soft Tissue",
    "Other"
  ],
  urgencyLevels: [
    "Routine",
    "Urgent",
    "Emergency"
  ],
  preferredTimeframes: [
    "Within 1 week",
    "Within 2 weeks",
    "Within 1 month",
    "Flexible / No preference"
  ]
};

export const contactData = {
  email: "secretary@krinapanchalphysio.com",
  phone: "+44 7899 121 612",
  whatsapp: "447899121612"
};

export const blogPostsData = [
  {
    id: 1,
    title: "Understanding TMD: Causes, Symptoms, and Treatment Options",
    excerpt: "Learn about temporomandibular disorders, what causes them, and how physiotherapy can help you find lasting relief.",
    image: "https://images.unsplash.com/photo-1542848285-4777eb2a621e?auto=format&fit=crop&w=1200&q=72",
    date: "2025-01-15",
    category: "TMD",
    readTime: "5 min read"
  },
  {
    id: 2,
    title: "The Connection Between Jaw Pain and Headaches",
    excerpt: "Discover how TMD can contribute to chronic headaches and migraines, and why treating your jaw might be the key to relief.",
    image: "https://images.unsplash.com/photo-1761718210055-e83ca7e2c9ad?auto=format&fit=crop&w=1200&q=72",
    date: "2025-01-10",
    category: "Headaches",
    readTime: "4 min read"
  },
  {
    id: 3,
    title: "5 Exercises to Relieve Jaw Tension at Home",
    excerpt: "Simple, effective exercises you can do at home to reduce jaw tension and improve mobility between treatment sessions.",
    image: "https://images.unsplash.com/photo-1706353399656-210cca727a33?auto=format&fit=crop&w=1200&q=72",
    date: "2025-01-05",
    category: "Self-Care",
    readTime: "6 min read"
  }
];
